import React, { Component } from 'react'
import {Container,Box, Grid, Typography, Button, Card, Paper, TextField, Divider} from "@mui/material"
import  hero from '../src/img/hero-image.webp'
import SendIcon from '@mui/icons-material/Send';
import PolylineIcon from '@mui/icons-material/Polyline';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import CheckIcon from '@mui/icons-material/Check';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import six from '../src/biodataimg/6.webp'
import five from '../src/biodataimg/5.webp'
import four from '../src/biodataimg/4.webp'
import there from '../src/biodataimg/3.webp'
import two from '../src/biodataimg/2.webp'
import one from '../src/biodataimg/1.webp'
import TranslateIcon from '@mui/icons-material/Translate';
import AddIcon from '@mui/icons-material/Add';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Appbars from '../src/Appbars'
import Footer from '../src/Footer'
import bg1 from '../src/background_img/bg1.jpg'
import bg2 from '../src/background_img/bg2.jpg'
import bg3 from '../src/background_img/bg3.jpg'
import bg4 from '../src/background_img/bg4.jpg'
import bg5 from '../src/background_img/bg5.jpg'
import bg6 from '../src/background_img/bg6.jpg'
import bg7 from '../src/background_img/bg7.jpg'
import bg8 from '../src/background_img/bg8.jpg'
import bg9 from '../src/background_img/bg9.jpg'
import bg10 from '../src/background_img/bg10.jpg'



export class Pageone extends Component {

constructor(props) {
  super(props)

  this.state = {
     name :"",
     gender:"",
     place_of_birth:"",
     date_of_birth:"",
     time_of_birth:"",
     nakshtra :"",
     height:"",
     marrital_status:"",
     religion:"",
     mother_tongue:"",
     cast:"",

     ///////////////// contact info 
     contact_no:"",
     father_contact:"",
     mother_contact_no :"",
     address :"",

     ///////////// family details ///////////

     father_name:"",
     mother_name:"",
     father_occupaion:"",
     mother_occupation:"",
     no_of_brother:"",
     no_of_sistser:"",




//////////////////////////////////////
     photo:"",


     bg_img:"bg1"


  }
}


handleChange=(e)=>{
this.setState({
  [e.target.name]:e.target.value
})
}


convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Reads the file as a data URL

      reader.onload = () => resolve(reader.result); // Resolves the promise with the data URL (base64 string)
      reader.onerror = (error) => reject(error);
    });
  }



handleChangee=async(e)=>{


const file = e.target.files[0];
    if (file) {
      try {
        const base64String = await this.convertToBase64(file);
        // The result will be a data URL string like "data:image/png;base64,iVBORw..."
        this.setState({
          photo:base64String
        })
      } catch (error) {
        console.error('Error converting image:', error);
      }
    }
}


generatePdf=()=>{

  let m = JSON.stringify({
     name : this.state.name,
     gender: this.state.gender,
     place_of_birth: this.state.place_of_birth,
     date_of_birth: this.state.date_of_birth,
     time_of_birth: this.state.time_of_birth,
     nakshtra : this.state.nakshtra,
     height: this.state.height,
     marrital_status: this.state.marrital_status,
     religion: this.state.religion,
     mother_tongue: this.state.mother_tongue,
     cast: this.state.cast,
     ///////////////// contact info 
     contact_no: this.state.contact_no,
     father_contact: this.state.father_contact,
     mother_contact_no : this.state.mother_contact_no,
     address : this.state.address,
     photo: this.state.photo,

     ///// family

        father_name: this.state.father_name,
     mother_name: this.state.mother_name,
     father_occupaion: this.state.father_occupaion,
     mother_occupation: this.state.mother_occupation,
     no_of_brother: this.state.no_of_brother,
     no_of_sistser: this.state.no_of_sistser,

     bg_img : this.state.bg_img
  })

  const encodedObject = encodeURIComponent(m)



 fetch(`https://api.ekbsapp.com/createMarriageReport`, {
      headers:{
        'authorization': `Bearer ${sessionStorage.getItem('token')}`,
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
                   url :`https://marriage.inccweb.in/reports?data=${encodedObject}`
            })
  
        }).then(function(response) {
          return response.json();
        })
        .then(async(data)=> {
        window.open('https://api.ekbsapp.com'+'/' + data.doc)
        });
      
}

  render() {
    return (
      <Box sx={{width:'100%'}}>
        <Appbars/>
        <Container maxWidth={{xs:'xxl',sm:'xl',md:'lg'}}>
     
             <Box style={{minHeight:500,backgroundColor:'#fff9ed',marginLeft:20,marginRight:20}}>
                <Grid container spacing={2}>
                  <Grid size={{xs:12,sm:12,md:6}}>
                    <Box sx={{minHeight:500,width:'100%'}}>

                      <Typography sx={{fontSize:{xs:30,sm:45},fontWeight:'600',mt:16,ml:3,display:'flex',flexDirection:'row'}}>Free Online <Typography sx={{color:'#e66402',fontSize:{xs:30,sm:45},fontWeight:'600',ml:2}}>Biodata</Typography></Typography>
                       
                       <Typography sx={{fontSize:{xs:30,sm:45},fontWeight:'600',ml:3,display:'flex',flexDirection:'row',mt:{xs:-1,sm:-3}}}><Typography sx={{color:'#e66402',fontSize:{xs:30,sm:45},fontWeight:'600',mr:2}}>Maker</Typography>— Create</Typography>

                       <Typography sx={{fontSize:{xs:30,sm:45},fontWeight:'600',ml:3,display:'flex',flexDirection:'row',mt:{xs:-1,sm:-3}}}>Marriage Biodata in 2 </Typography>
                         
                       <Typography sx={{fontSize:{xs:30,sm:45},fontWeight:'600',ml:3,display:'flex',flexDirection:'row',mt:{xs:-1,sm:-3}}}>Minutes</Typography>


                        <Typography textAlign='justify' sx={{mt:2,fontSize:17,fontWeight:'500',color:'grey',ml:1,mr:1}}>
                          Make biodata for marriage with 50+ beautiful templates for Indian communities. Free biodata format in your languages. Download your professional marriage biodata PDF instantly, no login needed.
                        </Typography>

                        <Box sx={{display:'flex',flexDirection:'row',ml:3,mt:3}}>
                          <Button variant="contained" startIcon={<PolylineIcon />} sx={{mr:2,textTransform:'none',backgroundColor:'#ff9f43',fontWeight:'bold',display:{xs:'none',sm:'flex'}}}>Create Biodata Online</Button>
                          <Button variant="outlined" startIcon={<DownloadForOfflineIcon />} sx={{textTransform:'none',fontWeight:'bold',display:{xs:'none',sm:'flex'}}}>View Download Biodata</Button>
                         
                           <Button variant="outlined" endIcon={<ArrowForwardIcon />} sx={{mr:2,textTransform:'none',fontWeight:'bold',display:{xs:'flex',sm:'none'},flexDirection:'row'}}>Create</Button>
                          <Button variant="outlined" endIcon={<DownloadForOfflineIcon />} sx={{mr:2,textTransform:'none',fontWeight:'bold',display:{xs:'flex',sm:'none'}}}>Download</Button>
                        </Box>

                           <Box sx={{mt:2,display:'flex',flexDirection:'row',ml:3}}>
                              <Typography sx={{fontSize:11,fontWeight:'bold',mr:2}}><CheckIcon sx={{height:10,width:10,mr:0.5,color:'green'}} />No Sign-up Required</Typography>
                               <Typography sx={{fontSize:11,fontWeight:'bold',mr:2}}><CheckIcon sx={{height:10,width:10,mr:0.5,color:'green'}} />100% Private & Secure</Typography>
                                <Typography sx={{fontSize:11,fontWeight:'bold',mr:2}}><CheckIcon sx={{height:10,width:10,mr:0.5,color:'green'}}/>59,227+ Biodata Created</Typography>
                           </Box>


                    </Box>
                  </Grid>
                   
                  <Grid size={{xs:12,sm:12,md:6}}>
                    <Box sx={{minHeight:200,width:'100%',display:'flex',justifyContent:'center',alignItems:'center',mt:{xs:0,sm:15}}}>


                          <img src={hero} style={{minHeight:250,width:'100%',objectFit:'contain',marginTop:5}}/>


                    </Box>
                   </Grid>

                </Grid>
             </Box>

             
             <Box sx={{backgroundColor:'#fffffd',minHeight:200,width:'100%'}}>
                 <Typography align='center' sx={{fontSize:27,fontWeight:'600',mt:5}}>Beautiful, Ready-to-Use Marriage Biodata Templates</Typography>
                 
                  <Typography align='center' sx={{display:'flex',textAlign:'center',fontSize:16,ml:{xs:'3%',sm:'25%'},mr:{xs:'3%',sm:'25%'},mt:2}}>
                     Authentic Marriage Biodata Templates for Every Indian Community. From Hindu (including Jain, Gujarati, Arya Vaishya, Marathi) to Muslim, Sikh, Christian, and more. find a design that truly represents you.
                  </Typography>   

                   <br/>
                 
                       <Box sx={{marginLeft:'5%',mr:'5%'}}>
                        <Grid container spacing={2}>
                         
                          <Grid size={{xs:12,sm:6,md:3}}>
                            <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={two} style={{height:330,width:'100%',borderRadius:5}}/>
                            </Paper>
                          </Grid>

                          <Grid size={{xs:12,sm:6,md:3}}>
                             <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={one} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>


                             <Grid size={{xs:12,sm:6,md:3}}>
                             <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={six} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>

                           <Grid size={{xs:12,sm:6,md:3}}>
                            <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={five} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>

                               <Grid size={{xs:12,sm:6,md:3}}>
                             <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={four} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>

                            <Grid size={{xs:12,sm:6,md:3}}>
                             <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={there} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>

                               <Grid size={{xs:12,sm:6,md:3}}>
                            <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={two} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>

                            <Grid size={{xs:12,sm:6,md:3}}>
                            <Paper elevation={1} sx={{height:330,width:'100%',backgroundColor:'green'}}>
                               <img src={one} style={{height:330,width:'100%'}}/>
                            </Paper>
                          </Grid>
                   
                    





                     </Grid>
                    </Box>



             </Box>
             
               
             <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',mt:2,mb:2}}>
              <Button variant="outlined" endIcon={<ArrowForwardIcon />} sx={{mr:2,textTransform:'none',fontWeight:'bold',display:{xs:'block',sm:'block'}}}>Create Biodata Online</Button>
                          
             </Box>


              <Box sx={{height:100,width:'100%',backgroundColor:'#fffaec',mt:2}}>
                   <Typography textAlign='center' sx={{fontSize:20,fontWeight:'bold',color:'black',pt:3}}>Create Marriage Biodata</Typography>
                     <Typography textAlign='center' sx={{fontSize:16,fontWeight:'500',color:'black'}}>Add your details to create a professional biodata.</Typography>
              </Box>

               
               




               <Box sx={{ml:{xs:'1%',sm:'18%'},mr:{xs:'1%',sm:'18%'},minHeight:500,backgroundColor:'pink',mt:2}}>
                  <Paper elevation={1} sx={{width:'100%',minHeight:500}}>
                          <br/>

                          <Box sx={{height:60,backgroundColor:'#f0f4ff',ml:'6%',mr:'6%',borderRadius:1,border:1,borderColor:'#e2f1ff',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                             <TranslateIcon sx={{color:'#008ffb',height:20,width:20}}/> <Typography sx={{fontSize:14,fontWeight:'bold',mr:1,ml:1,color:'#646464'}}>Form Language:</Typography> <TextField inputProps={{fontSize:11,fontweight:'bold', }} size='small' sx={{width:'70%',elevation:10}}  select fullWidth/>
                          </Box>    

                          
                           <Box sx={{height:20,backgroundColor:'#fef9c2',ml:'6%',mr:'6%',display:'flex',justifyContent:'center',alignItems:'center',mt:2,borderRadius:0.5,border:1,borderStyle:'dashed',borderColor:'#fff0e6'}}>
                            <Typography sx={{fontSize:10,color:'#008ffb'}}> Note: Simply leave a field blank to hide it. You can also edit labels or add new ones.</Typography>
                           </Box>

                            
                                  
                                  <Box sx={{m:3,justifyContent:'center',alignItems:'center',
                                     display: "flex",
                                                                flexDirection: "row",
                                                                overflowX: "scroll",
                                                                overflowY: "hidden",
                                                                mb: 1,
                                                                whiteSpace: "nowrap",
                                                                scrollbarWidth: "none",
                                  }}>
                                  {[bg1,bg2,bg3,bg4,bg5,bg6,bg7,bg8,bg9,bg10].map((i)=>(
                                    
                                    <Box onClick={()=>this.setState({bg_img:i})} sx={{height:100,width:80,mr:1,ml:1,border:3,borderColor:this.state.bg_img==i?'red':'grey'}}>
                                        <img src={i} style={{height:100,width:80,objectFit:'fill'}}/>
                                    </Box>

                                  ))

                                  } 
                                  </Box>
                  



                     


                          <Divider sx={{mt:2,mb:2}}/>

                           <Box sx={{ml:'6%',mr:'6%'}}>

                             <Typography sx={{fontSize:16,fontWeight:'bold',color:'#0d6efd'}}>Personal Details</Typography>
                              
                                                    <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          value={this.state.name}
                          onChange={this.handleChange}
                          name='name'
                          placeholder='Name'
                        />
                         
                         <Grid container spacing={1}>
                             <Grid item size={{xs:12,sm:4}}>
                             
                                             <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1},
                          }}
                          placeholder='Gender'
                            value={this.state.gender}
                          name='gender'
                           onChange={this.handleChange}
                        />
                             </Grid>
                             <Grid item size={{xs:12,sm:4}}>
                                  
                                             <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Place of birth'
                            value={this.state.place_of_birth}
                          name='place_of_birth'
                          onChange={this.handleChange}
                        />
                             </Grid>
                             <Grid item size={{xs:12,sm:4}}>
                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Date of birth'
                           value={this.state.date_of_birth}
                          name='date_of_birth'
                          onChange={this.handleChange}
                        />
                             </Grid>
                         </Grid>




                                            



                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Time of birth'
                           value={this.state.time_of_birth}
                          name='time_of_birth'
                          onChange={this.handleChange}
                        />



                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Nakshatra'
                          value={this.state.nakshtra}
                          name='nakshtra'
                          onChange={this.handleChange}
                        />



                         <Grid container spacing={1}>
                             <Grid item size={{xs:12,sm:4}}>
                              
                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Height'
                          value={this.state.height}
                          name='height'
                          onChange={this.handleChange}
                        />
                             </Grid>
                              <Grid item size={{xs:12,sm:4}}>
                               
                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Marrital status'
                          value={this.state.marrital_status}
                          name='marrital_status'
                          onChange={this.handleChange}
                        />

                             </Grid>
                              <Grid item size={{xs:12,sm:4}}>
                             
                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Religion'
                           value={this.state.religion}
                          name='religion'
                          onChange={this.handleChange}
                        />
                             </Grid>

                             </Grid>





                        
                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Mother toungue'
                           value={this.state.mother_tongue}
                          name='mother_tongue'
                          onChange={this.handleChange}
                        />

                        
                                                  <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Cast'
                          value={this.state.cast}
                          name='cast'
                          onChange={this.handleChange}

                        />

                      
                           </Box>

                          
                               <Divider sx={{mt:2,mb:2}}/>

                           <Box sx={{ml:'6%',mr:'6%'}}>

                             <Typography sx={{fontSize:16,fontWeight:'bold',color:'#0d6efd'}}>Contact Information</Typography>
                              
                                                    <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Contact No'
                           value={this.state.contact_no}
                          name='contact_no'
                          onChange={this.handleChange}
                        />

                                    <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Father s Contact No'
                           value={this.state.father_contact}
                          name='father_contact'
                          onChange={this.handleChange}
                        />


            <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder="Mother's Contact No"
                           value={this.state.mother_contact_no}
                          name='mother_contact_no'
                          onChange={this.handleChange}
                        />


            <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Address'
                            value={this.state.address}
                          name='address'
                          onChange={this.handleChange}
                        />


                           </Box>

                                  <Divider sx={{mt:2,mb:2}}/>

                           <Box sx={{ml:'6%',mr:'6%'}}>

                             <Typography sx={{fontSize:16,fontWeight:'bold',color:'#0d6efd'}}>Family Information</Typography>
                               
                               <Grid spacing={2}>
                                <Grid size={{xs:6,sm:3}}>

                                                    <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Father name'
                           value={this.state.father_name}
                          name='father_name'
                          onChange={this.handleChange}
                        />
                        </Grid>

 <Grid size={{xs:6,sm:3}}>
                                    <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Fathers occupation'
                           value={this.state.father_occupaion}
                          name='father_occupaion'
                          onChange={this.handleChange}
                        />
</Grid>
 <Grid size={{xs:6,sm:3}}>
            <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder="Mother's Contact No"
                           value={this.state.mother_name}
                          name='mother_name'
                          onChange={this.handleChange}
                        />
</Grid>
<Grid size={{xs:6,sm:3}}>
            <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='Mother occupation'
                            value={this.state.mother_occupation}
                          name='mother_occupation'
                          onChange={this.handleChange}
                        />
</Grid>
<Grid size={{xs:6,sm:3}}>
                      <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='No of sister'
                            value={this.state.no_of_sistser}
                          name='no_of_sistser'
                          onChange={this.handleChange}
                        />
</Grid>
<Grid size={{xs:6,sm:3}}>
                        <TextField
                                        sx={{mt:2}}
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 13, fontWeight: "600",boxShadow:1 },
                          }}
                          placeholder='No of brother'
                            value={this.state.no_of_brother}
                          name='no_of_brother'
                          onChange={this.handleChange}
                        />
                           </Grid>
                           </Grid>
                           </Box>


                                   <Divider sx={{mt:2,mb:2}}/>

                           <Box sx={{ml:'6%',mr:'6%'}}>

                             <Typography sx={{fontSize:16,fontWeight:'bold',color:'#0d6efd',mb:2}}>Photo Information</Typography>
                            
                          <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                          onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>

<br/>
<br/>

<Button variant='contained' onClick={this.generatePdf} startIcon={<ArrowDownwardIcon/>}>Download Bio Data</Button>

<br/>
<br/>
                           </Box>




                  </Paper>
               </Box>





<br/>





        </Container>
         <Footer/>
      </Box>
    )
  }
}

export default Pageone







